// Module
var code = `{{#if visible}}
    <div class="videoWidgetItemSideBar" on-click="onCardClick">
        <div class="videoWidgetItemSideBar-main-img">
            <img class="{{#if isShorts}}contain{{/if}}"
                src="{{videoPreviewURL}}" 
                alt="Video Thumbnail">
        </div>

        <div class="videoWidgetItemSideBar-body">
            <div class="videoWidgetItemSideBar-body-leftImg">
                <img src="{{channelPic}}" alt="Author Channel Logo">
            </div>

            <div class="videoWidgetItemSideBar-body-title">
                <div class="card-title-container">
                    <div class="card-title" as-tooltip="title.length > 80 ? title : ''">{{.title}}</div>
                    {{#if isShowData}}
                        <div class="card-date-4LIVE">
                            <div class="icon-img{{#if isLive}} live{{/if}}">
                                <svg>
                                    {{#if isLive}}
                                        <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#videoWidgetIconLive">
                                    {{else}}
                                        <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#videoWidgetIcon">
                                    {{/if}}
                                </svg>
                            </div>

                            <div class="text">
                                {{#if isLive}}
                                    {{localizedLIVE}}
                                {{else}}
                                    {{streamStartDateFormatted}}
                                {{/if}}
                            </div>
                        </div>
                    {{/if}}
                </div>
                <div class="card-author-name" as-tooltip="channelName.length > 40 ? channelName : ''">{{.channelName}}</div>
            </div>
        </div>
    </div>
{{/if}}`;
// Exports
export default code;